<template>
  <div v-if="open" class="modal-backdrop">
    <div class="modal">
      <h3>Auth Smoke Test Result</h3>
      <pre class="result">{{ result }}</pre>
      <div class="actions">
        <button @click="onCopy">Copy</button>
        <button @click="onClose">Close</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from "vue";

const props = defineProps<{ open: boolean; result: string }>();
const emit = defineEmits(["update:open", "close"]);

function onClose() {
  emit("update:open", false);
  emit("close");
}

function onCopy() {
  navigator.clipboard
    ?.writeText(props.result || "")
    .catch((e: unknown) => console.warn("Copy failed", e));
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.modal {
  background: white;
  padding: 1rem;
  border-radius: 8px;
  width: 600px;
  max-width: 95%;
}
.result {
  background: #f6f6f6;
  padding: 0.5rem;
  max-height: 40vh;
  overflow: auto;
}
.actions { display:flex; gap:0.5rem; justify-content:flex-end; margin-top:0.5rem }
</style>
